import { useEffect, useState } from 'react';
import ReasonService from 'views/reason/service';

export const useReasons = (selectedRecordType, isModalOpen) => {
  const [reasons, setReasons] = useState([]);
  const [isLoadingReasons, setIsLoadingReasons] = useState(false);

  useEffect(() => {
    if (!isModalOpen || !selectedRecordType) {
      setReasons([]);
      return;
    }

    const fetchReasons = async () => {
      setIsLoadingReasons(true);
      try {
        const response = await ReasonService.getByRecordType(
          Number(selectedRecordType)
        );
        setReasons(response?.data?.content || []);
      } catch (error) {
        console.error('Erro ao buscar motivos:', error);
        setReasons([]);
      } finally {
        setIsLoadingReasons(false);
      }
    };

    fetchReasons();
  }, [isModalOpen, selectedRecordType]);

  return { reasons, isLoadingReasons };
};
